export const state = () => ({
  apiUrl: {
    logGeneralSettingUrl: '/api/lr/command/log/apply'
  },
  deviceIdList: [],
  tamsLogdConfig: {
    'tamslogd.log_queue_yn': '1',
    'tamslogd.type': 'udp',
    'tamslogd.port': '3514'
  },
  logSett: {
    'log.cllct_yn': '1',
    'log.mon_relay_yn': '1',
    'log.relay_yn': '1',
    'log.relay_server1_ip': '',
    'log.relay_server1_logset': '',
    'log.relay_server1_port': '1514',
    'log.relay_server1_type': '0',
    'log.relay_server2_ip': '',
    'log.relay_server2_logset': '',
    'log.relay_server2_port': '1514',
    'log.relay_server2_type': '0',
    'log.relay_server3_ip': '',
    'log.relay_server3_logset': '',
    'log.relay_server3_port': '1514',
    'log.relay_server3_type': '0',
    'ipType1': 'ipv4',
    'ipType2': 'ipv4',
    'ipType3': 'ipv4',
    'log.tcp_port': '1515',
    'log.tcp_yn': '0',
    'log.tls_yn': '0',
    'log.udp_port': '1514',
    'log.udp_yn': '1'
  },
  defaultLogSett: {
    'log.relay_server1_logset': '',
    'log.relay_server2_logset': '',
    'log.relay_server3_logset': ''
  },
  // 로그설정결과
  logSettResult: null
})
export const mutations = {
  mutItemLogSetting (state, payload) {
    state.logSett[payload.key] = payload.val
  },
  mutSetDeviceList (state, payload) {
    state.deviceIdList = payload
  },
  mutSetTamsLogSetting (state, payload) {
    _.set(state, ['tamsLogdConfig', payload.key], payload.val)
  },
  mutLogSettings (state, payload) {
    state.logSett = _.assign(payload.config, {
      ipType1: _.get(payload.config, ['log.relay_server1_ip'], '').indexOf(':') > -1 ? 'ipv6' : 'ipv4',
      ipType2: _.get(payload.config, ['log.relay_server2_ip'], '').indexOf(':') > -1 ? 'ipv6' : 'ipv4',
      ipType3: _.get(payload.config, ['log.relay_server3_ip'], '').indexOf(':') > -1 ? 'ipv6' : 'ipv4',
      'relay_server1_port': _.get(payload.config, 'log.relay_server1_port', '1514'),
      'relay_server2_port': _.get(payload.config, 'log.relay_server2_port', '1514'),
      'relay_server3_port': _.get(payload.config, 'log.relay_server3_port', '1514')
      // 'relay_server1_logset': _.get(payload.config, 'log.relay_server1_logset'),
      // 'relay_server2_logset': _.get(payload.config, 'log.relay_server2_logset'),
      // 'relay_server3_logset': _.get(payload.config, 'log.relay_server3_logset')
    })
    state.defaultLogSett['log.relay_server1_logset'] = _.cloneDeep(JSON.parse(payload.config['log.relay_server1_logset']))
    state.defaultLogSett['log.relay_server2_logset'] = _.cloneDeep(JSON.parse(payload.config['log.relay_server2_logset']))
    state.defaultLogSett['log.relay_server3_logset'] = _.cloneDeep(JSON.parse(payload.config['log.relay_server3_logset']))
    state.logSett['log.relay_server1_logset'] = _.cloneDeep(state.defaultLogSett['log.relay_server1_logset'])
    state.logSett['log.relay_server2_logset'] = _.cloneDeep(state.defaultLogSett['log.relay_server2_logset'])
    state.logSett['log.relay_server3_logset'] = _.cloneDeep(state.defaultLogSett['log.relay_server3_logset'])
    state.deviceIdList = payload.device_id_list
    state.tamsLogdConfig = payload.tamslogd_config
  },
  mutPutLogSettings (state, payload) {
    state.logSettResult = payload
  }
}
export const actions = {
  // 로그 관리 설정 정보 조회
  async acsLogSettings ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(`${state.apiUrl.logGeneralSettingUrl}`, null, {
        loading: false,
        successAlert: false
      })

      if (res.code === 'ok') {
        commit('mutLogSettings', res.result.msg)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // 로그/리포트 관리 설정
  async acsPutLogSettings ({commit, state}, payload) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$put(`${state.apiUrl.logGeneralSettingUrl}`, payload, {
        applyMsg: true,
        loading: true,
        successAlert: true
      })

      if (res.code === 'ok') {
        commit('mutPutLogSettings', res)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  }
}

export const getters = {}
export const strict = false
